import React, { useMemo } from 'react'

import {
  // eslint-disable-next-line camelcase
  Menus_ContainsAlcohol,
  Menus_MenuItemTag,
  Menus_ContentAdvisories
} from 'src/apollo/onlineOrdering'

import { useRestaurant } from 'shared/components/common/restaurant_context/RestaurantContext'

import { DEFAULT_COLORS } from 'public/components/default_template/meta/StyleMeta'
import {
  MenuItemTag,
  OfferBadge
} from 'public/components/default_template/online_ordering/item_tags/MenuItemTags'

// eslint-disable-next-line camelcase
const ALCOHOL_ITEM_TAG: Menus_MenuItemTag = { name: 'ID REQUIRED' }

// eslint-disable-next-line camelcase
export const useItemTags = (
  menuItemTags: Menus_MenuItemTag[] = [],
  contentAdvisories?: Menus_ContentAdvisories
) => {
  const itemTags = useMemo(() => {
    // eslint-disable-next-line camelcase
    const tags: Menus_MenuItemTag[] = []
    // eslint-disable-next-line camelcase

    // eslint-disable-next-line no-extra-parens, camelcase
    if (
      contentAdvisories?.alcohol?.containsAlcohol === Menus_ContainsAlcohol.Yes
    ) {
      tags.push(ALCOHOL_ITEM_TAG)
    }

    return [...tags, ...(menuItemTags ?? [])]
  }, [contentAdvisories?.alcohol?.containsAlcohol, menuItemTags])

  return itemTags
}

type ItemTagsProps = {
  offersText: string[]
  // eslint-disable-next-line camelcase
  itemTags: Menus_MenuItemTag[] | undefined
}
export const ItemTags = ({ offersText, itemTags = [] }: ItemTagsProps) => {
  const {
    restaurant: {
      meta: { primaryColor, theme }
    }
  } = useRestaurant()

  const fallbackColor = primaryColor ?? DEFAULT_COLORS.primary ?? '#000000'
  const tagColor = theme?.enabled
    ? theme.colorScheme.border.default
    : fallbackColor

  return (itemTags && itemTags.length > 0) || offersText.length > 0 ? (
    <div className='itemTagsCardContainer wrap' data-testid='menu-item-tags'>
      {offersText.map((offer) => (
        <OfferBadge key={offer} text={offer.toUpperCase()} />
      ))}
      {itemTags?.map((tag) => (
        <MenuItemTag
          key={tag.guid || tag.name}
          subtle
          tagColor={tagColor}
          testId='item-tag'
        >
          {tag.name?.toUpperCase()}
        </MenuItemTag>
      ))}
    </div>
  ) : null
}
